import { setGlobalModal, setGlobalModalMetadata } from 'actions/index'

export const openEditReviewAutomationSettingsModal = product => async dispatch => {
  dispatch(setGlobalModalMetadata({ ...product }))
  dispatch(setGlobalModal('ProductSettingsModal'))
}
